export default "__VITE_ASSET__C_BKocCv__"